export const base_path = "/";
export const img_path = "/";
export const API_BASE_URL = process.env.REACT_APP_API_URL;
